import React from 'react';
export default (function (_a) {
    var className = _a.className, ariaHidden = _a["aria-hidden"], color = _a.color;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: className, "aria-hidden": ariaHidden },
        React.createElement("path", { d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" }),
        React.createElement("line", { x1: "7", y1: "7", x2: "7.01", y2: "7" })));
});
